import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingHeaderInformation } from '../../components/NewbuildingHeaderInformation';
import {
  getAddress,
  getName,
  getLabels,
  getConstructionStatus,
  getBuilder,
  getNewbuildingUrl,
  getUnderground,
} from '../../selectors/newbuildingHeader';

export const NewbuildingHeaderInformationContainer: React.FC = () => {
  const address = useSelector(getAddress);
  const title = useSelector(getName);
  const labels = useSelector(getLabels);
  const status = useSelector(getConstructionStatus);
  const builder = useSelector(getBuilder);
  const url = useSelector(getNewbuildingUrl);
  const underground = useSelector(getUnderground);

  return (
    <NewbuildingHeaderInformation
      title={title}
      url={url}
      address={address}
      builder={builder}
      status={status}
      labels={labels}
      underground={underground}
    />
  );
};
